const locations = [
  {
    name: "Gate Theatre",
    address: "Gate Theatre, Rotunda, Dublin, Co. Dublin, 1, Ireland",
    latitude: 53.353059,
    longitude: -6.2619635,
  },
  {
    name: "Leonardo Hotel",
    address: "17 - 19 Moore Ln, North City, Dublin, D01 H6K3, Ireland",
    latitude: 53.3517321,
    longitude: -6.2626394,
  },

  {
    name: "Chapter One Restaurant",
    address: "18-19 Parnell Square N, Rotunda, Dublin 1, D01 T3V8, Ireland",
    latitude: 53.3544157,
    longitude: -6.2639458,
  },
  {
    name: "Garden of Remembrance",
    address: "Parnell Square E, Rotunda, Dublin 1, D01 A0F8, Ireland",
    latitude: 53.3538817,
    longitude: -6.2641428,
  },
  {
    name: "The Spire",
    address: "O'Connell Street Upper, North City, Dublin, Ireland",
    latitude: 53.349806,
    longitude: -6.2602544,
  },

  {
    name: "Gear Jewellers",
    address:
      "Greeg Court, Unit 3 Parnell St, North City, Dublin, D01 XC62, Ireland",
    latitude: 53.3510728,
    longitude: -6.2639384,
  },
];

const locationsLeft = [
  {
    name: "Rotunda Hospital",
    address: "Parnell Square E, Rotunda, Dublin 1, D01 P5W9, Ireland",
    latitude: 53.3530919,
    longitude: -6.2631779,
  },
  {
    name: "Kingfisher Restaurant",
    address: "166-168, 166-168 Parnell St, Rotunda, Dublin, D01 DX43, Ireland",
    latitude: 53.3518079,
    longitude: -6.2633806,
  },
  {
    name: "Chapters Bookstore",
    address: "Ivy Exchange, Parnell St, Rotunda, Dublin 1, D01 P8C2, Ireland",
    latitude: 53.3515089,
    longitude: -6.2639632,
  },
  {
    name: "Ilac Shopping Centre Car Park",
    address: "Parnell St, North City, Dublin 1, D01 TF70, Ireland",
    latitude: 53.3506872,
    longitude: -6.2648771,
  },
  {
    name: "An Post, General Post Office",
    address: "O'Connell Street Lower, North City, Dublin 1, D01 F5P2, Ireland",
    latitude: 53.3494452,
    longitude: -6.2603496,
  },
];

async function initMap() {
  let lat, lng, zoom;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    lat = 53.35112260348137;
    lng = -6.2621859704301714;
    zoom = 16.4;
  } else {
    lat = 53.3507135750317;
    lng = -6.2621859704301714;
    zoom = 16.89;
  }
  // Request needed libraries.
  const { Map } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
  const map = new Map(document.getElementById("mapCustomMarkerBYMohsin"), {
    center: { lat: lat, lng: lng },
    zoom: zoom,
    mapId: "faa547091873c246",
  });

  // Create a global InfoWindow instance
  const infoWindow = new google.maps.InfoWindow();

  function handleMapClick(event) {
    infoWindow.close();
  }

  // Add click listener for desktop
  map.addListener("click", handleMapClick);

  // Add touchend listener for mobile
  map.addListener("touchend", handleMapClick);

  locations.forEach((location) => {
    let htmlString;
    // Replace " | " with an empty string
    if (location.name === "Gear Jewellers") {
      // Your HTML string
      htmlString = `
                <div style="display: flex; align-items: flex-end;">
                    <p style="right: -265px; margin: 0px 35px -16px 0px;" class="markerHeadingN">${location.name}</p>
                    <img style=" width: 66px;height: 66px;" class="defaultImageMarker" src="/cdn/shop/t/259/assets/${location.name}.png" alt="custom icon">
                        
                </div>`;
    } else {
      // Your HTML string
      htmlString = `
                <div style="display: flex;align-items: center;">
                    <p class="markerHeadingN">${location.name}</p>
                    <div class="marker-shape">
                        
                    </div>
                </div>`;
    }

    // Create a temporary DOM element to parse the HTML string
    const tempDiv = document.createElement("div");
    tempDiv.className = "customMarker";
    tempDiv.innerHTML = htmlString;

    const marker = new AdvancedMarkerElement({
      map,
      position: { lat: location.latitude, lng: location.longitude },
      content: tempDiv,
    });

    marker.addListener("click", () => {
      const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        location.address
      )}`;
      // Create InfoWindow content
      infoWindow.setContent(`
        <div class="info-window-content">
            <h3 class="infoHeading">${location.name}</h3>
            <a target="_blank" href="${googleMapsLink}" class="infoLink">${location.address}</a>
        </div>`);

      infoWindow.open(map, marker);
    });
  });

  // left side text locations
  locationsLeft.forEach((location) => {
    let htmlString;
    // Replace " | " with an empty string
    if (location.name === "Ilac Shopping Centre Car Park") {
      location.name = location.name.replace("|", "");

      // Your HTML string
      htmlString = `
                <div style="display: flex; align-items: center;">
                    <p class="markerHeadingNLeft">${location.name}</p>
                    <img class="defaultImageMarker" src="/cdn/shop/t/259/assets/${location.name}.png" alt="custom icon">
                        
                </div>`;
    } else {
      // Your HTML string
      htmlString = `
                <div style="display: flex;align-items: center;">
                    <p class="markerHeadingNLeft">${location.name}</p>
                    <div class="marker-shape">
                        
                    </div>
                </div>`;
    }

    // Create a temporary DOM element to parse the HTML string
    const tempDiv = document.createElement("div");
    tempDiv.className = "customMarker";
    tempDiv.innerHTML = htmlString;

    const markerLeft = new AdvancedMarkerElement({
      map,
      position: { lat: location.latitude, lng: location.longitude },
      content: tempDiv,
    });
    markerLeft.addListener("click", () => {
      const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        location.address
      )}`;

      // Create InfoWindow content
      infoWindow.setContent(`
        <div class="info-window-content">
            <h3 class="infoHeading">${location.name}</h3>
            <a target="_blank" href="${googleMapsLink}" class="infoLink">${location.address}</a>
        </div>`);

      infoWindow.open(map, markerLeft);
    });
  });
}

initMap();
